import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NC } from '../nonconformities-api.model';

@Component({
  selector: 'app-nonconformity-dialog',
  templateUrl: './nonconformity-dialog.component.html',
  styleUrls: ['./nonconformity-dialog.component.scss'],
})
export class NonconformityDialogComponent {
  public nonconformityType: string;
  public nonconformity?: NC;

  public nonconformityId?: string;

  constructor(
    public dialogRef: MatDialogRef<NonconformityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any | null
  ) {
    if (data) {
      this.nonconformity = data.nonconformity;
      this.nonconformityType = data.nonconformityType;

      this.nonconformityId = data.nonconformity?.id;
    }
    dialogRef.disableClose = true;
    dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.onEscape();
      }
    });
  }

  public save(): void {
    const nonconformity = {
      nonconformityType: this.nonconformityType,
      nonconformity: this.nonconformity,
    };
    this.dialogRef.close(nonconformity);
  }

  private onEscape(): void {
    this.dialogRef.close(false);
  }
}
